module.exports = __webpack_public_path__ + "static/media/landingpage_visuals.026e61b9.png";